module.exports = "/deep/ .mat-dialog-content{display:contents !important}\n"